import { Injectable } from '@angular/core';
import {
  throwError as observableThrowError,
  Observable,
  of as observableOf,
} from 'rxjs';
import {
  map,
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

import { ApiService } from './api.service';
import { ILocation } from '../interfaces/location';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  constructor(private _apiService: ApiService) {}

  findCEP(cep: string): Observable<ILocation> {
    return this._apiService.doGET('localizacao/' + cep).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getOrderSituation(): Observable<any> {
    return this._apiService.doGET('order-situations').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getBrands(): Observable<any> {
    let urlParams = new HttpParams();
    urlParams = urlParams.set('onlyStore', 'S');

    return this._apiService.doGET('brands', urlParams).pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }

  getMethodPayments(): Observable<any> {
    return this._apiService.doGET('method-payments').pipe(
      catchError((err) => {
        return observableOf([]);
      })
    );
  }
}
